import React, { useEffect, useState } from 'react'
import { Input, Button } from '@/components/atoms/index'
import WordTableList from '@/components/organisms/Table/AcademyWordTable'
import WordSelectionContent from '@/components/Modal/WordSelectionContent'
import { Dialog } from '@/components/organisms/Modal/Dialog'
import { Modal } from '@/components/organisms/Modal/Modal'
import Toggle from '@/components/atoms/Toggle/Toggle'
import { useNavigate, useParams } from 'react-router-dom'
import { academyWordbookApi } from '@/services/api'
import { useSessionSlug } from '@/hooks/useSessionSlug'
import dayjs from 'dayjs'

// const wordData = [
//     {
//         id: '1',
//         wordCode: 'WB001',
//         word: 'apple',
//         meaning: '사과',
//         ttsType: '영어',
//         isPublic: true,
//         registrant: '김영어',
//         createdAt: '2024-01-15',
//         uploadStatus: 'completed' as const,
//     },
//     {
//         id: '2',
//         wordCode: 'WB002',
//         word: 'book',
//         meaning: '책',
//         ttsType: '영어',
//         isPublic: true,
//         registrant: '김영어',
//         createdAt: '2024-01-15',
//         uploadStatus: 'completed' as const,
//     },
//     {
//         id: '3',
//         wordCode: 'WB003',
//         word: 'cat',
//         meaning: '고양이',
//         ttsType: '영어',
//         isPublic: false,
//         registrant: '김영어',
//         createdAt: '2024-01-15',
//         uploadStatus: 'failed' as const,
//     },
//     {
//         id: '4',
//         wordCode: 'WB004',
//         word: 'dog',
//         meaning: '개',
//         ttsType: '영어',
//         isPublic: true,
//         registrant: '김영어',
//         createdAt: '2024-01-15',
//         uploadStatus: 'completed' as const,
//     },
//     {
//         id: '5',
//         wordCode: 'WB005',
//         word: 'elephant',
//         meaning: '코끼리',
//         ttsType: '영어',
//         isPublic: true,
//         registrant: '김영어',
//         createdAt: '2024-01-15',
//         uploadStatus: 'completed' as const,
//     }
// ]

export default function AcademyWordbookDetail() {
  const navigate = useNavigate()
  const { wordbookId } = useParams()
  const { academyCode: sessionAcademyCode } = useSessionSlug()
  const academyCode = sessionAcademyCode || ''
  const [wordSelectionModalOpen, setWordSelectionModalOpen] = useState(false)
  const [selectedWords, setSelectedWords] = useState<any[]>([])
  const [title, setTitle] = useState('')
  const [isPublic, setIsPublic] = useState(true)
  const [registrant, setRegistrant] = useState('')
  const [createdAt, setCreatedAt] = useState('')
  const [saving, setSaving] = useState(false)
  const [ownerAcademyCode, setOwnerAcademyCode] = useState<string | null | undefined>(undefined)
  const [usageCount, setUsageCount] = useState(0)

  const isReadOnly =
    Boolean(wordbookId) &&
    (
      ownerAcademyCode === null ||
      (ownerAcademyCode !== undefined && ownerAcademyCode !== academyCode)
    )
  const handleDeleteSelectedWord = (id: string) => {
    setSelectedWords(prev => prev.filter((w:any) => String(w.id) !== String(id)))
  }

  const handleWordSelectionOk = (words: any[]) => {
    setSelectedWords((prev:any[]) => {
      const existing = new Set(prev.map((w:any) => String(w.id)))
      const toAdd = (words || []).filter((w:any) => !existing.has(String(w.id)))
      return [...prev, ...toAdd]
    })
    setWordSelectionModalOpen(false)
  }

  const handleWordSelectionCancel = () => {
    setWordSelectionModalOpen(false)
  }

  const confirmWordbookUpdate = () => {
    return Modal.confirm({
        title: '학습이력이 있는 단어장입니다.',
      message: '이미 학습에 사용된 단어장을 수정하면 학생 화면에도 바로 반영됩니다. 계속 진행하시겠습니까?',
        okText: '확인',
        cancelText: '취소',
    })
  }

  const handleRegister = async () => {
    if (isReadOnly) {
      await Modal.alert({ message: '다른 학원이 공개한 단어장은 수정할 수 없습니다.' })
      return
    }

    const cleanedTitle = (title || '').trim()
    if (!cleanedTitle) {
      await Modal.alert({ message: '단어장명을 입력해주세요.' })
      return
    }
    if (!Array.isArray(selectedWords) || selectedWords.length === 0) {
      await Modal.alert({ message: '단어를 1개 이상 선택해주세요.' })
      return
    }
    const wordIds = (selectedWords
      .map((w:any) => Number(w.id))
      .filter((id): id is number => typeof id === 'number' && !Number.isNaN(id))) as number[]
    if (wordbookId && usageCount > 0) {
      const confirmed = await confirmWordbookUpdate()
      if (!confirmed) return
    }

    setSaving(true)
    try {
      const registrantName = localStorage.getItem('academy_user_name') || ''
      const registrantUserId = Number(localStorage.getItem('academy_user_id') || 0) || undefined
      if (!academyCode) {
        await Modal.alert({ message: '학원 정보를 불러오지 못했습니다.' })
        return
      }
      if (wordbookId) {
        await academyWordbookApi.update(wordbookId, { title: cleanedTitle, isPublic, wordIds: wordIds as any, registrantUserId, academyCode })
      } else {
        await academyWordbookApi.create({ title: cleanedTitle, isPublic, registrant: registrantName, wordIds: wordIds as any, registrantUserId, academyCode })
      }
      await Modal.alert({ message: '단어장 저장이 완료되었습니다.' })
      navigate('/academy/word/word_book/list')
    } finally {
      setSaving(false)
    }
  }

  useEffect(() => {
    const load = async () => {
      if (!wordbookId) return
      const res = await academyWordbookApi.detail(wordbookId)
      const d = res?.data || res
      setTitle(d.title || '')
      setIsPublic(!!d.isPublic)
      setRegistrant(d.registrant || '')
      setCreatedAt((d.createdAt || '').toString().substring(0, 10))
      setOwnerAcademyCode(typeof d.ownerAcademyCode === 'string' ? d.ownerAcademyCode : null)
      const words = Array.isArray(d.words) ? d.words.map((w:any) => ({
        id: String(w.id),
        wordCode: w.wordCode || w.code || '',
        word: w.word,
        meaning: w.meaning,
        ttsType: w.ttsType,
        isPublic: true,
        registrant: '',
        createdAt: '',
        uploadStatus: 'completed' as const,
      })) : []
      setSelectedWords(words)
      setUsageCount(Number(d.usageCount || 0))
    }
    load()
  }, [wordbookId])

  useEffect(() => {
    if (wordbookId) return
    const registrantName = localStorage.getItem('academy_user_name') || ''
    setRegistrant(registrantName || '-')
    setCreatedAt(dayjs().format('YYYY-MM-DD'))
  }, [wordbookId])

  return (
    <main className='flex flex-col flex-1 pt-8 relative'>
      {saving && (
        <div className='absolute inset-0 z-20 flex flex-col gap-3 items-center justify-center bg-white/70 backdrop-blur-[1px]'>
          <div className='w-48 h-2 bg-gray-200 rounded-full overflow-hidden'>
            <div className='h-full w-full bg-indigo-500 animate-pulse' />
          </div>
          <p className='text-sm text-gray-600'>단어장을 저장하는 중입니다...</p>
        </div>
      )}
      <div className='flex flex-row justify-between items-start'>
        <h1 className='heading1'>{wordbookId ? '단어장 수정' : '단어장 등록'}</h1>
      </div>
      {isReadOnly && (
        <div className='mb-4 rounded-lg border border-yellow-200 bg-yellow-50 px-4 py-3 text-sm text-yellow-800'>
          다른 학원이 공개한 단어장입니다. 내용을 수정할 수 없으며 단어만 열람할 수 있습니다.
        </div>
      )}
        <ul className='w-full'>
            <li className='flex py-5 border-b border-gray-200'>
                <p className='flex-none max-w-[150px] w-full text-gray-500'>단어장명</p>    
                <Input  placeholder='단어장 제목을 입력해주세요' className='max-w-[500px] w-full' value={title} onChange={(e:any)=>setTitle(e?.target?.value || '')} disabled={isReadOnly}/>
            </li>
            <li className='flex py-5 border-b border-gray-200'>
                <p className='flex-none max-w-[150px] w-full text-gray-500'>단어 설정</p>    
                <div className='w-full'>
                    <Button onClick={() => !isReadOnly && setWordSelectionModalOpen(true)} disabled={isReadOnly}>단어 선택</Button>
                    <div className='w-full'>
                        <p className='py-4 text-sm text-gray-500'>업로드 단어 된 단어</p>
                        <div className='w-full max-w-[800px] max-h-[300px] overflow-y-auto'>
                            <WordTableList data={selectedWords} type='wordBookUpload' onDelete={isReadOnly ? undefined : handleDeleteSelectedWord}/>
                        </div>
                    </div>
                </div>
            </li>
            <li className='flex py-5 border-b border-gray-200'>
                <p className='flex-none max-w-[150px] w-full text-gray-500'>공개 설정</p>
                <div className='flex items-center gap-4'>
                    <Toggle
                        checked={isPublic}
                        onChange={setIsPublic}
                        disabled={isReadOnly}
                    />
                    <span className='text-sm text-gray-600'>
                        {isPublic ? '공개' : '비공개'}
                    </span>
                </div>
            </li>

            <li className='flex py-5 border-b border-gray-200'>
                <p className='flex-none max-w-[150px] w-full text-gray-500'>등록자</p>    
                <p className='max-w-[500px] w-full'>{registrant || '-'}</p>
            </li>
            <li className='flex py-5 border-b border-gray-200'>
                <p className='flex-none max-w-[150px] w-full text-gray-500'>등록일</p>    
                <p className='max-w-[500px] w-full'>{createdAt || '-'}</p>
            </li>
        </ul>
        <section className='flex justify-end py-5 gap-2'>
            <Button intent='secondary' onClick={()=>navigate(-1)}>뒤로가기</Button>
            <Button intent='primary' onClick={handleRegister} disabled={saving || isReadOnly}>
              {isReadOnly ? '읽기 전용' : (wordbookId ? '수정하기' : '등록하기')}
            </Button>
        </section>
        
            <Dialog 
                open={wordSelectionModalOpen}
                className="w-full !max-w-[800px]" 
                hideFooter={true}
            >
                <WordSelectionContent 
                    onOk={handleWordSelectionOk}
                    onCancel={handleWordSelectionCancel}
                />
            </Dialog>
    </main>
  )
}